import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import apiV2 from '../../../services/apiV2';
import { ClassroomDayControls } from './ClassroomDayControls';

export function RequirementObservations({ sectionId }: { sectionId?: number }) {
  const [opened, setOpened] = useState(false);
  const [catalog, setCatalog] = useState<any>(null);
  const [error, setError] = useState('');
  useEffect(() => {
    if (!opened || !sectionId) return;
    let active = true;
    setCatalog(null); setError('');
    apiV2.get(`/pathways/sections/${sectionId}/`).then(r => { if (active) setCatalog(r.data); })
      .catch(() => { if (active) setError('Could not load requirements. Refresh to try again.'); });
    return () => { active = false; };
  }, [opened, sectionId]);
  return <details className="mt-5 rounded-xl border border-border bg-surface p-5" onToggle={e => { if (e.currentTarget.open) setOpened(true); }}>
    <summary className="cursor-pointer font-medium">Teacher observations & readiness</summary>
    <div className="mt-4">
      {!sectionId ? <p>Choose a specific class in the header to record observations.</p> : error ? <p role="alert">{error}</p> : !catalog ? <p role="status">Loading requirements...</p> : !catalog.requirements.length ? <p>No readiness or lab requirements for this class yet. <Link className="text-brand underline" to={`/v2/teacher/pathways?section=${sectionId}`}>Add a requirement in Learning plans</Link>.</p> : <ClassroomDayControls key={sectionId} sectionId={String(sectionId)} catalog={catalog} reloadCatalog={async () => { const r = await apiV2.get(`/pathways/sections/${sectionId}/`); setCatalog(r.data); }} mode="observations" />}
    </div>
  </details>;
}
